var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox" },
    [
      _c("pages-header", {
        ref: "pageHeader",
        attrs: {
          title: _vm.operateMaps[_vm.op] || "-",
          backUrl: "/operation/applet/list",
        },
      }),
      _c(
        "el-card",
        {
          staticClass: "box-card mt14",
          attrs: {
            "body-style": { padding: "0 20px 20px" },
            shadow: "never",
            bordered: false,
          },
        },
        [
          _c(
            "el-form",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              ref: "formData",
              staticClass: "formData form-boder-padding",
              attrs: {
                rules: _vm.ruleValidate,
                model: _vm.formData,
                "label-width": "160px",
              },
              nativeOn: {
                submit: function ($event) {
                  $event.preventDefault()
                },
              },
            },
            [
              _c(
                "el-row",
                { attrs: { gutter: 24 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "应用名称：", prop: "appName" } },
                        [
                          _c("el-input", {
                            staticClass: "from-ipt-width",
                            attrs: {
                              maxlength: "100",
                              "show-word-limit": "",
                              placeholder: "请输入应用名称",
                              disabled: _vm.isDisabled,
                            },
                            model: {
                              value: _vm.formData.appName,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.formData,
                                  "appName",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression: "formData.appName",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "应用环境：", prop: "appType" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticClass: "from-ipt-width",
                              attrs: { placeholder: "请选择应用环境" },
                              model: {
                                value: _vm.formData.appType,
                                callback: function ($$v) {
                                  _vm.$set(_vm.formData, "appType", $$v)
                                },
                                expression: "formData.appType",
                              },
                            },
                            _vm._l(_vm.appTypeOptions, function (item, index) {
                              return _c("el-option", {
                                key: index,
                                attrs: { label: item.label, value: item.value },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                      _vm.formData.appType === 1
                        ? [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: "小程序appid：",
                                  prop: "appId",
                                },
                              },
                              [
                                _c("el-input", {
                                  staticClass: "from-ipt-width",
                                  attrs: {
                                    maxlength: "100",
                                    "show-word-limit": "",
                                    placeholder: "请输入",
                                    disabled: _vm.isDisabled,
                                  },
                                  model: {
                                    value: _vm.formData.appId,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.formData,
                                        "appId",
                                        typeof $$v === "string"
                                          ? $$v.trim()
                                          : $$v
                                      )
                                    },
                                    expression: "formData.appId",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: "小程序密钥：",
                                  prop: "appSecret",
                                },
                              },
                              [
                                _c("el-input", {
                                  staticClass: "from-ipt-width",
                                  attrs: {
                                    maxlength: "100",
                                    "show-word-limit": "",
                                    placeholder: "请输入",
                                    disabled: _vm.isDisabled,
                                  },
                                  model: {
                                    value: _vm.formData.appSecret,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.formData,
                                        "appSecret",
                                        typeof $$v === "string"
                                          ? $$v.trim()
                                          : $$v
                                      )
                                    },
                                    expression: "formData.appSecret",
                                  },
                                }),
                              ],
                              1
                            ),
                          ]
                        : _vm._e(),
                      _vm.formData.appType === 2
                        ? [
                            _c(
                              "el-form-item",
                              { attrs: { label: "域名：", prop: "domain" } },
                              [
                                _c("el-input", {
                                  staticClass: "from-ipt-width",
                                  attrs: {
                                    "show-word-limit": "",
                                    placeholder: "请输入",
                                    disabled: _vm.isDisabled,
                                  },
                                  model: {
                                    value: _vm.formData.domain,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.formData,
                                        "domain",
                                        typeof $$v === "string"
                                          ? $$v.trim()
                                          : $$v
                                      )
                                    },
                                    expression: "formData.domain",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: "微信公众号appid：",
                                  prop: "publicWechatAppid",
                                },
                              },
                              [
                                _c("el-input", {
                                  staticClass: "from-ipt-width",
                                  attrs: {
                                    maxlength: "100",
                                    "show-word-limit": "",
                                    placeholder: "请输入",
                                    disabled: _vm.isDisabled,
                                  },
                                  model: {
                                    value: _vm.formData.publicWechatAppid,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.formData,
                                        "publicWechatAppid",
                                        typeof $$v === "string"
                                          ? $$v.trim()
                                          : $$v
                                      )
                                    },
                                    expression: "formData.publicWechatAppid",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: "微信公众号密钥：",
                                  prop: "publicWechatSecret",
                                },
                              },
                              [
                                _c("el-input", {
                                  staticClass: "from-ipt-width",
                                  attrs: {
                                    maxlength: "100",
                                    "show-word-limit": "",
                                    placeholder: "请输入",
                                    disabled: _vm.isDisabled,
                                  },
                                  model: {
                                    value: _vm.formData.publicWechatSecret,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.formData,
                                        "publicWechatSecret",
                                        typeof $$v === "string"
                                          ? $$v.trim()
                                          : $$v
                                      )
                                    },
                                    expression: "formData.publicWechatSecret",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: "微信验证Token：",
                                  prop: "verifyToken",
                                },
                              },
                              [
                                _c("el-input", {
                                  staticClass: "from-ipt-width",
                                  attrs: {
                                    maxlength: "100",
                                    "show-word-limit": "",
                                    placeholder: "请输入",
                                    disabled: _vm.isDisabled,
                                  },
                                  model: {
                                    value: _vm.formData.verifyToken,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.formData,
                                        "verifyToken",
                                        typeof $$v === "string"
                                          ? $$v.trim()
                                          : $$v
                                      )
                                    },
                                    expression: "formData.verifyToken",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: "EncodingAESKey：",
                                  prop: "encodingAesKey",
                                },
                              },
                              [
                                _c("el-input", {
                                  staticClass: "from-ipt-width",
                                  attrs: {
                                    maxlength: "100",
                                    "show-word-limit": "",
                                    placeholder: "请输入",
                                    disabled: _vm.isDisabled,
                                  },
                                  model: {
                                    value: _vm.formData.encodingAesKey,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.formData,
                                        "encodingAesKey",
                                        typeof $$v === "string"
                                          ? $$v.trim()
                                          : $$v
                                      )
                                    },
                                    expression: "formData.encodingAesKey",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: "H5跳转小程序支付：",
                                  prop: "bindMiniProgramSwitch",
                                },
                              },
                              [
                                _c("el-switch", {
                                  attrs: {
                                    "active-text": "启用",
                                    "inactive-text": "禁用",
                                    "active-value": 1,
                                    "inactive-value": 0,
                                  },
                                  model: {
                                    value: _vm.formData.bindMiniProgramSwitch,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.formData,
                                        "bindMiniProgramSwitch",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "formData.bindMiniProgramSwitch",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "el-form-item",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.formData.bindMiniProgramSwitch,
                                    expression:
                                      "formData.bindMiniProgramSwitch",
                                  },
                                ],
                                attrs: {
                                  label: "H5跳转小程序支付小程序：",
                                  prop: "bindMiniProgramId",
                                },
                              },
                              [
                                _c(
                                  "el-select",
                                  {
                                    staticClass: "from-ipt-width",
                                    attrs: {
                                      placeholder: "请选择小程序",
                                      filterable: "",
                                    },
                                    model: {
                                      value: _vm.formData.bindMiniProgramId,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.formData,
                                          "bindMiniProgramId",
                                          $$v
                                        )
                                      },
                                      expression: "formData.bindMiniProgramId",
                                    },
                                  },
                                  _vm._l(_vm.wxappList, function (item) {
                                    return _c("el-option", {
                                      key: item.id,
                                      attrs: {
                                        label: item.appName,
                                        value: item.id,
                                      },
                                    })
                                  }),
                                  1
                                ),
                              ],
                              1
                            ),
                          ]
                        : _vm._e(),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "微信支付配置：",
                            prop: "wechatPayMerchantConfigIds",
                          },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticClass: "from-ipt-width",
                              attrs: {
                                placeholder: "请选择微信支付配置",
                                filterable: "",
                                multiple: "",
                              },
                              model: {
                                value: _vm.formData.wechatPayMerchantConfigIds,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.formData,
                                    "wechatPayMerchantConfigIds",
                                    $$v
                                  )
                                },
                                expression:
                                  "formData.wechatPayMerchantConfigIds",
                              },
                            },
                            _vm._l(_vm.wxchatPayList, function (item) {
                              return _c("el-option", {
                                key: item.id,
                                attrs: {
                                  label: item.merchantName,
                                  value: item.id,
                                },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "企微客服链接：",
                            prop: "consumerH5Url",
                          },
                        },
                        [
                          _c("el-input", {
                            staticClass: "from-ipt-width",
                            attrs: {
                              placeholder: "请输入",
                              disabled: _vm.isDisabled,
                            },
                            model: {
                              value: _vm.formData.consumerH5Url,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.formData,
                                  "consumerH5Url",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression: "formData.consumerH5Url",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "企微corpId：", prop: "corpId" } },
                        [
                          _c("el-input", {
                            staticClass: "from-ipt-width",
                            attrs: {
                              placeholder: "请输入",
                              disabled: _vm.isDisabled,
                            },
                            model: {
                              value: _vm.formData.corpId,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.formData,
                                  "corpId",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression: "formData.corpId",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "状态：", prop: "status" } },
                        [
                          _c("el-switch", {
                            attrs: {
                              "active-text": "启用",
                              "inactive-text": "禁用",
                              "active-value": 1,
                              "inactive-value": 0,
                            },
                            model: {
                              value: _vm.formData.status,
                              callback: function ($$v) {
                                _vm.$set(_vm.formData, "status", $$v)
                              },
                              expression: "formData.status",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    2
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "hasPermi",
                          rawName: "v-hasPermi",
                          value: [
                            "platform:system:applet:save",
                            "platform:system:applet:update",
                          ],
                          expression:
                            "['platform:system:applet:save', 'platform:system:applet:update']",
                        },
                        {
                          name: "show",
                          rawName: "v-show",
                          value: !_vm.isDisabled,
                          expression: "!isDisabled",
                        },
                      ],
                      staticClass: "submission",
                      attrs: { type: "primary", loading: _vm.loadingBtn },
                      on: {
                        click: function ($event) {
                          return _vm.handleSubmit("formData")
                        },
                      },
                    },
                    [_vm._v("保存")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }